export enum FontSizeType {
  LONG = "long",
  MIDDLE = "middle",
  SHORT = "short",
  ROADMAP = 'roadmap',
}

export const getResponsiveFontSize = (vwSize: number, width: number) => {
  return Math.round((vwSize * width) / 100);
};

// Calculate adaptive font sizes based on text length
export const getAdaptiveFontSize = (
  baseVwSize: number,
  textLength: number,
  windowWidth: number,
  type: FontSizeType
) => {
  const baseSize = getResponsiveFontSize(baseVwSize, windowWidth);

  let lengthFactor: number;

  if (type === FontSizeType.SHORT) {
    lengthFactor = Math.max(0.2, 1 - (textLength - 10) / 60);
  } else if (type === FontSizeType.MIDDLE) {
    lengthFactor = Math.max(0.5, 1 - (textLength - 30) / 150);
  } else if (type === FontSizeType.LONG) {
    lengthFactor = Math.max(0.7, 1 - (textLength - 170) / 200);
  } else {
 lengthFactor = Math.max(0.7, 1 - (textLength - 120) / 50);
  }

  return Math.round(baseSize * lengthFactor);
};
